import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

function cloneSlides( container, minSlides = 10 ) {
  const wrapper = container.querySelector( '.e-div--icon-card .swiper-wrapper' );
  const slides = wrapper.querySelectorAll( '.e-div--icon-card .swiper-slide' );

  if ( slides.length < minSlides ) {
    const clonesNeeded = minSlides - slides.length;
    for ( let i = 0; i < clonesNeeded; i++ ) {
      const clone = slides[i % slides.length].cloneNode( true );
      clone.classList.add( 'slide-clone' );
      wrapper.appendChild( clone );
    }
  }
}

document.addEventListener( 'DOMContentLoaded', () => {
  const swiperContainer = document.querySelector( '.e-div--icon-card .swiper' );
  if ( !swiperContainer ) return;

  cloneSlides( swiperContainer, 15 );
  const swiper = new Swiper( swiperContainer, {
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    loop: true,
    slidesPerView: 'auto',
    slidesToScroll: 1,
    allowTouchMove: false,
    longSwipesRatio: 0.1,
    speed: 5000,
  } );

  requestAnimationFrame( () => {
    const swiperWrapperEl = swiper.el.querySelector( '.swiper-wrapper' );
    swiperWrapperEl.style.setProperty( 'transition-timing-function', 'var(--easing)' );

    const setEasing = ( easing = 'ease' ) => {
      swiperWrapperEl.style.setProperty( '--easing', easing );
    };

    let duration;
    let startTimer;

    const stopAutoplay = () => {
      if ( startTimer ) clearTimeout( startTimer );
      swiper.setTranslate( swiper.getTranslate() );

      const currentSlideWidth = swiper.slides[swiper.activeIndex].offsetWidth;
      const distanceRatio = Math.abs(
        ( currentSlideWidth * swiper.activeIndex + swiper.getTranslate() ) / currentSlideWidth
      );

      duration = swiper.params.speed * distanceRatio;
      swiper.autoplay.stop();
    };

    const startAutoplay = ( delay = duration ) => {
      startTimer = setTimeout( () => {
        setEasing( 'linear' );
        swiper.autoplay.start();
      }, delay );
    };

    const handleSlideOut = () => {
      const distance = swiper.width * swiper.activeIndex + swiper.getTranslate();
      duration = distance !== 0 ? duration : 0;
      swiper.slideTo( swiper.activeIndex, duration );
      startAutoplay();
    };

    const handleTogglePlay = ( toggle ) => {
      if ( toggle === 'in' ) stopAutoplay();
      else handleSlideOut();
    };

    const debounce = ( func, delay ) => {
      let timer;
      return ( ...args ) => {
        clearTimeout( timer );
        timer = setTimeout( () => func( ...args ), delay );
      };
    };

    const debouncedHandleTogglePlay = debounce( handleTogglePlay, 100 );

    swiper.el.querySelectorAll( '.swiper-slide a' ).forEach( ( link ) => {
      link.addEventListener( 'pointerenter', () => debouncedHandleTogglePlay( 'in' ) );
      link.addEventListener( 'pointerleave', () => debouncedHandleTogglePlay( 'out' ) );
    } );
  } );
} );
